export default __webpack_public_path__ + "static/media/peugeot-astra.807f8f8a.svg";